import React, { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'
import styles from './mobileNavigation.module.scss'
import { MobileSubmenuProps } from '../types'
import { getLocalizedPath } from '../utils'
import { ReactComponent as CloseIcon } from '../../../images/icons/icn_close.svg'
import { ReactComponent as BackIcon } from '../../../images/icons/icn_arrow_left.svg'

const MobileSubmenu: React.FC<MobileSubmenuProps> = ({
  isActive,
  title,
  items,
  onClose,
  onCloseMenu,
}) => {
  const { t } = useTranslation(['strCommonUI'])
  const submenuRef = useRef<HTMLDivElement>(null)

  return (
    <div
      ref={submenuRef}
      className={classNames(styles.mobileSubmenuContainer, { [styles.open]: isActive })}
      aria-hidden={!isActive}
      data-testid='mobile-submenu'
    >
      <div className={styles.submenuHeaderControls}>
        <button className={styles.backButton} onClick={onClose} aria-label={t('link.back')}>
          <BackIcon />
        </button>

        <button
          className={styles.mobileMenuCloseButton}
          onClick={onClose}
          aria-label={t('button.close', 'Close Menu')}
        >
          <CloseIcon />
        </button>
      </div>

      <div className={styles.submenuHeaderTitle}>
        <h2 className={styles.submenuTitle}>{title}</h2>
      </div>

      <ul className={styles.submenuList}>
        {items.map((item, index) => (
          <li key={item.id ?? index} className={styles.submenuItem}>
            <a
              href={getLocalizedPath(item.path)}
              className={styles.submenuLink}
              onClick={onCloseMenu}
            >
              {item.name}
            </a>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default MobileSubmenu
